(function () {
  document.addEventListener('DOMContentLoaded', function () {
    var frameUrls = window.scrollHeroFrames || [];
    if (!frameUrls.length) return;

    var wrapper = document.getElementById('scrollHero');
    var canvas = document.getElementById('scrollHeroCanvas');
    var ctx = canvas.getContext('2d');
    var cueEl = wrapper.querySelector('.scroll-hero__scrollcue');

    var images = new Array(frameUrls.length);
    var loaded = 0;
    var ready = false;

    frameUrls.forEach(function (src, i) {
      var img = new Image();
      img.onload = function () {
        loaded++;
        if (i === 0) {
          canvas.width = img.naturalWidth;
          canvas.height = img.naturalHeight;
          ctx.drawImage(img, 0, 0);
        }
        if (loaded === frameUrls.length) {
          ready = true;
        }
      };
      img.src = src;
      images[i] = img;
    });

    var currentFrame = -1;

    function drawFrame(index) {
      if (index === currentFrame) return;
      var img = images[index];
      if (!img || !img.complete || !img.naturalWidth) return;
      ctx.clearRect(0, 0, canvas.width, canvas.height);
      ctx.drawImage(img, 0, 0);
      currentFrame = index;
    }

    function onScroll() {
      var rect = wrapper.getBoundingClientRect();
      var scrollDistance = wrapper.offsetHeight - window.innerHeight;
      if (scrollDistance <= 0) return;

      var progress = -rect.top / scrollDistance;
      progress = Math.max(0, Math.min(1, progress));

      var frameIndex = Math.round(progress * (frameUrls.length - 1));
      drawFrame(frameIndex);

      // hide the "scroll" cue once the user starts scrolling
      cueEl.classList.toggle('is-hidden', progress > 0.03);
    }

    var ticking = false;
    function requestTick() {
      if (!ticking) {
        window.requestAnimationFrame(function () {
          onScroll();
          ticking = false;
        });
        ticking = true;
      }
    }

    window.addEventListener('scroll', requestTick, { passive: true });
    window.addEventListener('resize', requestTick);
    window.addEventListener('load', onScroll);
  });
})();
